import type { BisacCode } from "reedy-data/api";

export interface BisacSubject {
  prefix: string;
  heading: string;
  codes: BisacCode[];
}

export const SUBJECT_PREFIX_LENGTH = 3;
export const BISAC_HEADING_SEPARATOR = " / ";

export const groupBisacSubjects = (codes: BisacCode[]): BisacSubject[] => {
  const subjects = new Map<string, BisacSubject>();

  for (const code of codes) {
    const prefix = code.code.slice(0, SUBJECT_PREFIX_LENGTH);
    const subject = subjects.get(prefix) ?? {
      prefix,
      heading: code.headingPath[0],
      codes: [],
    };
    subject.codes.push(code);
    subjects.set(prefix, subject);
  }

  return [...subjects.values()];
};
